import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_VSnackbar = _resolveComponent("VSnackbar")!

  return (_openBlock(), _createBlock(_component_VSnackbar, {
    modelValue: _ctx.toastVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toastVisible) = $event)),
    timeout: "3000"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.toastMessage) + " ", 1 /* TEXT */),
      _createVNode(_component_v_btn, {
        color: "pink",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toastVisible = false))
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Close")
        ])),
        _: 1 /* STABLE */,
        __: [2]
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}